/* @flow */

import classNames from 'classnames';
import { Field } from 'formik';
import { compose } from 'ramda';
import * as React from 'react';
import { createUseStyles } from 'react-jss';

import styles from './PreferencesCheckbox.style';

import useEventAccentColor from 'src/shared/domain/event/hook/useEventAccentColor';

type Props = {
  name: string,
  children: string,
  isDisabled?: boolean,
};

const useStyles = createUseStyles(styles);

const PreferencesCheckbox = ({
  name,
  children,
  isDisabled,
}: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */

  const [accentColor] = useEventAccentColor();

  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes: Object = useStyles({ accentColor });

  const labelClasses = classNames(classes.label, {
    [`${classes['label-isDisabled']}`]: isDisabled,
  });

  /*
    |---------------------------------------------------------------------------
    | Elements
    |---------------------------------------------------------------------------
    */

  return (
    <Field name={name}>
      {({ field, form }) => (
        <div className={classes.group}>
          <input
            id={name}
            name={name}
            type="checkbox"
            checked={field.value}
            onChange={() => form.setFieldValue(name, !field.value)}
          />
          <label className={labelClasses} htmlFor={name}>
            <span className={classes.subLabel}>{children}</span>
          </label>
        </div>
      )}
    </Field>
  );
};

export default compose(React.memo)(PreferencesCheckbox);
